<template>
  <div ref="mainHigh" class="main">
    <page v-if="bottom_nav_ico==0"></page>
    <user v-else></user>
    <div class="bottom_nav">
      <div @click="goRouter(0)" class="item_nav">
        <div><img v-if="bottom_nav_ico==0" src="./img/formon.png" alt=""><img v-else src="./img/form.png" alt=""></div>
        <span v-if="bottom_nav_ico==0" style="color:#1c4ff7">微测评</span>
        <span v-else>微测评</span>
      </div>
      <div @click="goRouter(1)" class="item_nav">
        <div><img v-if="bottom_nav_ico==1" src="./img/useron.png" alt=""><img v-else src="./img/user.png" alt=""></div>
        <span v-if="bottom_nav_ico==1" style="color:#1c4ff7">我的</span>
        <span v-else>我的</span>
      </div>
    </div>
  </div>
</template>

<script>

import page from './page'
import user from './user'

export default {
  components: {
    page,
    user
  },
  data() {
    return {
      bottom_nav_ico: null,
    }
  },
  mounted() {
    this.bottom_nav_ico = this.$route.query.bottom_nav_ico ? this.$route.query.bottom_nav_ico : 0
    this.$refs.mainHigh.style.height = window.innerHeight + 'px'
  },
  methods: {

    //添加路由参数
    goRouter(str) {
      this.bottom_nav_ico = str
      this.$router.push({query: {bottom_nav_ico: str}})
    },
  },
}
</script>

<style scoped lang="less">
.main {
  font-family: '微软雅黑';
  background: #fafafa;
  width: 100%;

  .bottom_nav {
    box-shadow: 1px 1px 10px 1px #a7a7a7;
    position: fixed;
    bottom: 0;
    font-size: .8rem;
    width: 100%;
    height: 3.5rem;
    background: #fff;
    display: flex;

    .item_nav {
      flex: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: 1rem;
      }
    }
  }
}
</style>
